// removed by extract-text-webpack-plugin
module.exports = {"imageWrapper":"PrimaryImage__imageWrapper--3XRoE","placeholder":"PrimaryImage__placeholder--1a1TC","img":"PrimaryImage__img--25evc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/PrimaryImage/PrimaryImage.css
// module id = ./src/components/Library/PrimaryImage/PrimaryImage.css
// module chunks = 1